/* eslint-disable no-unused-vars */
/* eslint-disable prefer-rest-params */
const throttle = (func, threshhold) => {
  let inThrottle;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    const now = new Date();
    if (lastRan && lastRan + threshhold > now) {
      clearTimeout(inThrottle);
      inThrottle = setTimeout(() => {
        lastRan = new Date();
        func.apply(context, arguments);
      }, threshhold);
    } else {
      func.apply(context, arguments);
      lastRan = new Date();
    }
  };
};
export default throttle;
